import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface VideoPlayerSkeletonProps {
  aspectRatio?: number;
  posterUrl?: string;
}

/** Reserves the video player's footprint while the player chunk loads. */
export const VideoPlayerSkeleton = ({
  aspectRatio,
  posterUrl,
}: VideoPlayerSkeletonProps) => (
  <div
    className={classNames("relative", {
      "aspect-video": !aspectRatio,
    })}
    style={aspectRatio ? { aspectRatio } : undefined}
    aria-hidden="true"
  >
    <div className="bg-secondary absolute inset-0" />
    {posterUrl && (
      <img
        loading="lazy"
        src={posterUrl}
        alt=""
        className="absolute inset-0 size-full object-cover"
      />
    )}
    <div className="animate-shimmer absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent bg-[length:1000px_100%] bg-no-repeat" />
  </div>
);
